import { render } from "./weekPicker.vue?vue&type=template&id=06d09e6c&scoped=true"
import script from "./weekPicker.vue?vue&type=script&lang=js"
export * from "./weekPicker.vue?vue&type=script&lang=js"

import "./weekPicker.vue?vue&type=style&index=0&id=06d09e6c&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/weektodo/weektodo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d09e6c"]])

export default __exports__